import { Button, Form, Input, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import * as palette from "../../styles/variables";
import { addData } from "../../utils/services/available-data";

export const AddAvailableData = ({ cancel, updatedData }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
 

  const onAddData = (values) => {
    setLoading(true);
    addData(
      values,
      (res) => {
        setLoading(false);
        updatedData(res.data);
        cancel();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  return (
    <FormContainer>
      <Form
        form={form}
        name="Add available data"
        colon={false}
        requiredMark={false}
        labelCol={{ span: 24 }}
        onFinish={onAddData}
        autoComplete="off"
      >
        <div className="formItems">
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter the name",
              },
            ]}
          >
            <Input
              placeholder="Enter the name"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>
            

          <Form.Item
            label="Value"
            name="value"
            rules={[
              {
                required: true,
                message: "Please enter the value.",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter the value"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>

          <Form.Item
            label="Mins/Etimate"
            name="estimate"
            rules={[
              {
                required: true,
                message: "Please enter the value.",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter the value"
              style={{
                width: "98%",
              }}
            />
          </Form.Item>
 
        </div>
        <div className="footerBtn">
          <Form.Item>
            <Button className="outlinedBtn" onClick={cancel}>
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              className="primaryBtn"
              htmlType="submit"
              style={{ padding: "0px 24px" }}
              disabled={loading}
            >
              Save
            </Button>
          </Form.Item>
        </div>
      </Form>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  padding: 20px 0px;
  .formItems {
    display: grid;
    grid-template-columns: auto auto auto;
    @media only screen and (max-width: 769px) {
      grid-template-columns: auto auto;
    }
  }
  .footerBtn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 20px 30px 0px;
    gap: 20px;
    .ant-form-item {
      margin-bottom: 0px;
    }
  }
`;
